import {Text} from '@dropbox/dig-components/typography';
import {Box, Stack} from '@dropbox/dig-foundations';
import {
  KNOWLEDGE_SOURCES,
  knowledgeLinkState,
  logKnowledgeHomeItemClicked,
} from 'analytics/knowledgeAnalytics';
import {Link} from 'components/DSYS/Link';
import {getKnowledgeGuidePath} from 'constant';
import {t} from 'i18next';

import {useKnowledgeGuides} from './guideHooks';

const browseLinkState = knowledgeLinkState(KNOWLEDGE_SOURCES.home);

/** Knowledge home card for the curated guides Ask also searches. */
export const KnowledgeGuidesCard = () => {
  const {data} = useKnowledgeGuides();
  const guides = data?.guides ?? [];
  if (guides.length === 0) {
    return null;
  }

  return (
    <Box
      borderColor="Border Base"
      borderStyle="Solid"
      borderWidth="1"
      borderRadius="Medium"
      padding="16"
    >
      {/* Stack spaces children with margins, which inline links ignore. */}
      <Stack gap="8">
        <Text isBold>{t('knowledge_guides')}</Text>
        {guides.map((guide, index) => (
          <Box key={guide.id}>
            <Link
              to={getKnowledgeGuidePath(guide.id)}
              state={browseLinkState}
              monochromatic
              hasNoUnderline
              showUnderlineOnHover
              onClick={() =>
                logKnowledgeHomeItemClicked({itemType: 'guide', mode: 'browse', rank: index + 1})
              }
            >
              <Text color="subtle">{guide.title}</Text>
            </Link>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
